import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/index";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: () => import('@/views/account/index'),
            meta: {
                noLogin: true
            }
        },
        {
            path: '/load',
            component: () => import('@/views/load/load'),
            meta: {
                noLogin: true
            }
        },
        {
            path: '/login',
            component: () => import('@/views/account/index'),
        },
        {
            path: '/oauth2',
            component: () => import('@/views/home/home'),
            meta: {
                noLogin: true
            }
        },
        {
            path: '/test',
            component: () => import('@/views/test/testapi')
        },
        {
            path: '/market',
            component: () => import('@/views/market/mark-list'),
            children: [
                {
                    path: '/marketAdd',
                    component: () => import('@/views/market/mark-add'),
                },
                {
                    path: '/marketMain',
                    component: () => import('@/views/market/mark-main'),
                },
                {
                    path: '/marketDetail',
                    component: () => import('@/views/market/mark-detail'),
                },
                {
                    path: '/marketUpdate',
                    component: () => import('@/views/market/detail-pop/mark-update'),
                },
            ]
        },
        {
            path: '/index',
            component: () => import('@/views/index/index'),
            children: [{
                path: '/home',
                component: () => import('@/views/home/home')
            },
                {
                    path: '/menu',
                    component: () => import('@/views/menu/menu')
                },
                {
                    path: '/userList',
                    component: () => import('@/views/user/user-list')
                },
                {
                    path: '/operation',
                    component: () => import('@/views/operation/operation')
                },
                {
                    path: '/organization',
                    component: () => import('@/views/org/org')
                },
                {
                    path: '/testTree',
                    component: () => import('@/views/test')
                },
                {
                    path: '/rolebinding',
                    component: () => import('@/views/rolebinding/rolebinding')
                },
                {
                    path: '/dict',
                    component: () => import('@/views/dict/dict')
                },
                {
                    path: '/roleManage',
                    component: () => import('@/views/role/role-manage')
                },
                {
                    path: '/score',
                    component: () => import('@/views/score/score-list')
                },
                {
                    path: '/student',
                    component: () => import('@/views/student/student-list')
                },
                {
                    path: '/class',
                    component: () => import('@/views/class/class-list')
                },
                {
                    path: '/school',
                    component: () => import('@/views/school/school-list')
                },
                {
                    path: '/exam',
                    component: () => import('@/views/exam/exam-list')
                },
                {
                    name: 'SeatTemplate',
                    path: '/SeatTemplate',
                    component: () => import('@/views/template/SeatTemplate')
                },
                {
                    path: '/PersonnelTemplate',
                    component: () => import('@/views/template/PersonnelTemplate')
                },
                {
                    name: 'RowOfSeats',
                    path: '/RowOfSeats',
                    component: () => import('@/views/template/RowOfSeats')
                },
                {
                    name: 'room',
                    path: '/room',
                    component: () => import('@/views/room/room')
                },
                {
                    name: 'SeatsSearch',
                    path: '/SeatsSearch',
                    component: () => import('@/views/template/SeatsSearch')
                },
                {
                    name: 'showStudent',
                    path: '/showStudent',
                    component: () => import('@/views/showStudent/show-list')
                },
                {
                    name: 'showRecords',
                    path: '/showRecords',
                    component: () => import('@/views/showRecords/show-records')
                },
                {
                    name: 'outerList',
                    path: '/outer',
                    component: () => import('@/views/outer/outer-list')
                },
                {
                    name: 'outerAppraise',
                    path: '/outerAppraise',
                    component: () => import('@/views/outerAppraise/appraise-list')
                },
                {
                    path: '/orgbinduser',
                    component: () => import('@/views/org/orgbinduser')
                },
                {
                    path: '/setting',
                    component: () => import('@/views/setting/settings-list')
                },
            ]
        }
    ]
})
router.beforeEach((to, from, next) => {
    const token = store.getters.getToken;
    if (to.path == "/oauth2") {
        //这里将token 放入vuex中
        store.commit('set_token', to.query.token);
        // token = to.query.token;
        //这里跳转路由 登录成功的
        router.push("/home");
        /*this.$api.sys.getUserInfo().then(userInfo=>{
          store.commit('setUserInfo',userInfo.data);
        });*/
        return;
    }
    if (to.matched.some(record => record.meta.noLogin)) {
        //路由元信息requireAuth:true，或者homePages:true，则不做登录校验
        next()
    } else {
        if (token) { //判断用户是否登录
            if (Object.keys(from.query).length === 0) { //判断路由来源是否有query，处理不是目的跳转的情况
                next()
            } else {
                let redirect = from.query.redirect //如果来源路由有query
                if (to.path === redirect) { //这行是解决next无限循环的问题
                    next()
                } else {
                    next({
                        path: redirect
                    }) //跳转到目的路由
                }
            }
        } else {
            if (to.path === "/login") {
                next({
                    path: "/",
                    query: {
                        redirect: from.fullPath
                    } //将目的路由地址存入login的query中
                })
            } else {
                next({
                    path: "/",
                    query: {
                        redirect: to.fullPath
                    } //将目的路由地址存入login的query中
                })
            }
        }
    }
    return
})
export default router
